import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { NotificationsProvider } from "@/contexts/NotificationsContext";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import HowItWorks from "@/pages/HowItWorks";
import Packages from "@/pages/Packages";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import HeirloomPage from "@/pages/HeirloomPage";
import SampleHeirloom from "@/pages/SampleHeirloom";
import HeirloomPreview from "@/pages/HeirloomPreview";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import ProjectEditor from "@/pages/admin/ProjectEditor";
import OpsLogin from "@/pages/ops/OpsLogin";
import OpsAdmin from "@/pages/ops/OpsAdmin";
import OpsAdminDashboard from "@/pages/ops/OpsAdminDashboard";
import OpsInterviewer from "@/pages/ops/OpsInterviewer";
import OpsInterviewerDashboard from "@/pages/ops/OpsInterviewerDashboard";
import OpsProduction from "@/pages/ops/OpsProduction";
import OpsProductionDashboard from "@/pages/ops/OpsProductionDashboard";
import OpsNotifications from "@/pages/ops/OpsNotifications";
import ClientSelection from "@/pages/ClientSelection";
import ClientSelectionPreview from "@/pages/ops/ClientSelectionPreview";

function App() {
  return (
    <AuthProvider>
      <NotificationsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/get-started" element={<Navigate to="/contact" replace />} />
          <Route path="/heirloom/:slug" element={<HeirloomPage />} />
          <Route path="/sample" element={<SampleHeirloom />} />
          <Route path="/admin/preview/:projectId" element={<HeirloomPreview />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/projects/new" element={<ProjectEditor />} />
          <Route path="/admin/projects/:projectId" element={<ProjectEditor />} />
          <Route path="/ops/login" element={<OpsLogin />} />
          {/* Legacy routes redirect to new /dashboard landing */}
          <Route path="/ops/admin" element={<Navigate to="/ops/admin/dashboard" replace />} />
          <Route path="/ops/interviewer" element={<Navigate to="/ops/interviewer/dashboard" replace />} />
          <Route path="/ops/production" element={<Navigate to="/ops/production/dashboard" replace />} />
          {/* New dashboards */}
          <Route path="/ops/admin/dashboard" element={<OpsAdminDashboard />} />
          <Route path="/ops/admin/leads" element={<OpsAdmin />} />
          <Route path="/ops/admin/unassigned" element={<OpsAdmin />} />
          <Route path="/ops/admin/keepsakes" element={<OpsAdmin />} />
          <Route path="/ops/admin/templates" element={<OpsAdmin />} />
          <Route path="/ops/admin/packages" element={<OpsAdmin />} />
          <Route path="/ops/admin/team" element={<OpsAdmin />} />
          <Route path="/ops/interviewer/dashboard" element={<OpsInterviewerDashboard />} />
          <Route path="/ops/interviewer/pipeline" element={<OpsInterviewer />} />
          <Route path="/ops/production/dashboard" element={<OpsProductionDashboard />} />
          <Route path="/ops/production/jobs" element={<OpsProduction />} />
          <Route path="/ops/notifications" element={<OpsNotifications />} />
          <Route path="/select/:token" element={<ClientSelection />} />
          <Route path="/ops/leads/:leadId/preview" element={<ClientSelectionPreview />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
      </NotificationsProvider>
    </AuthProvider>
  );
}

export default App;
